module.exports = __webpack_public_path__ + "static/media/header-wave.1bc027e8.png";